import { useTypedParams } from '@sorare/routing';

import { UserWatchlists } from '#src/components/profile/UserWatchlists/index.tsx';

import type { PageParams } from './__generated__/routeParams.ts';

const Watchlists = () => {
  const { slug } = useTypedParams<PageParams>();
  return <UserWatchlists slug={slug} />;
};

export default Watchlists;
